<template>
  <div class="title">{{title}}</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => '',
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 30px;
  text-align: center;
  padding: 10px 0;
  margin-bottom: 10px;
  border-bottom: 2px solid;
  color: red;
}
</style>